export default function initTeamMember(): void {
  Alpine.data('teamMember', () => ({
    isOpen: false,

    init() {
      this.$watch('isOpen', () => {
        this.$refs.holder.classList.toggle('active');
      });
    },

    open() {
      this.isOpen = true;
    },

    close() {
      this.isOpen = false;
    },
  }));
}
